/* @flow */

import { TextFieldBase } from "./TextFieldBase";

const TextField = class extends TextFieldBase<HTMLInputElement> {};

export default TextField;
